module.exports = __webpack_public_path__ + "static/media/logo.45377fd6.svg";